import RateCard, { RateCardProps } from './RateCard';

export type { RateCardProps };
export default RateCard;
